import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sureroute-test',
  templateUrl: './sureroute-test.component.html',
  styleUrls: ['./sureroute-test.component.css'],
})
export class SurerouteTestComponent {
  sureRouteUrl: string;
  //constructor() { }
  ngOnInit(): void {
    const ALLOWED_PATHS = ['https://techdocs.akamai.com/property-mgr/docs/sureroute-beh'];
    const parsedUrl = `https://techdocs.akamai.com/property-mgr/docs/sureroute-beh`;
    const containsSubstring = ALLOWED_PATHS.some(item => item.includes(parsedUrl));
    if (containsSubstring) {
      this.sureRouteUrl = parsedUrl;
    } else {
      this.sureRouteUrl = '';
    }
  }
}
